import React from 'react';
import {useStyles} from "./ShowPaymentMethod.style";
import ShowPaymentMethodProperties from "./ShowPaymentMethodProperties";
import clsx from "clsx";
import {useI18nContext} from "../../../contexts/I18nContext";
import PaymentMethod from "../../../entities/PaymentMethod";
import CashPaymentIcon from "../../../ui_components/Icon/icons/CashPaymentIcon";
import ZelleIcon from "../../../ui_components/Icon/icons/ZelleIcon";
import WireTransferIcon from "../../../ui_components/Icon/icons/WireTransferIcon";
import CreditCardSharpIcon from "@mui/icons-material/CreditCardSharp";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import CheckPaymentIcon from "../../../ui_components/Icon/icons/CheckPaymentIcon";
import { CurrencyModule } from '../../../util/Currency';
import PermPhoneMsgIcon from '@mui/icons-material/PermPhoneMsg';
import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt';

const ShowPaymentMethod: React.FC<ShowPaymentMethodProperties> = ({
                                                          className = '',
                                                          amount,
                                                          extraFee = null,
                                                          paymentMethod,
                                                          light = false
                                                      }) => {
    const classes = useStyles(light);
    const i18n = useI18nContext();

    const getIcon = () => {
        switch (paymentMethod) {
            case PaymentMethod.CASH:
                return <CashPaymentIcon/>;
            case PaymentMethod.ZELLE:
                return <ZelleIcon/>;
            case PaymentMethod.BANK_TRANSFER:
                return <WireTransferIcon/>;
            case PaymentMethod.DEBIT_CARD:
                return <CreditCardSharpIcon/>;
            case PaymentMethod.CREDIT_CARD:
                return <CreditCardIcon/>;
            case PaymentMethod.CHECK:
                return <CheckPaymentIcon/>;
            case PaymentMethod.OTHER:
                return <PermPhoneMsgIcon/>;
        }
    }

    return (
        <div className={clsx(classes.payment_type_info_container, className)}>
            {paymentMethod && <div className={clsx(classes.icon)}>{getIcon()}</div>}
            {!paymentMethod && <div className={clsx(classes.icon)}><DoNotDisturbAltIcon/></div>}
            <div className={classes.info}>
                {amount && <div>{CurrencyModule.format(amount)}</div>}
                <div>{i18n.translate(`PAYMENT_TYPE_${paymentMethod}`)}</div>
                {!!extraFee && <div className={classes.fee}>{`+ ${CurrencyModule.format(extraFee)}`}</div>}
            </div>
        </div>
    )
}
export default ShowPaymentMethod;